import logoNormal from 'assets/img/logo-normal.svg'
import CustomMarker from 'components/ui/Map/CustomMarker'
import HeatmapLayer from 'components/ui/Map/HeatmapLayer'
import { Field, Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import { LuFilter, LuFlame, LuMapPin } from 'react-icons/lu'
import { MapContainer, Popup, TileLayer } from 'react-leaflet'
import Select from 'react-select'
import { Link } from 'wouter'

export default function MapFormDetail({
  type,
  fields,
  filteredIncidents,
  positionOptions,
  incidentRef,
  mapRef,
  handleFilter,
  showHeatmap,
  onToggleHeatmap
}) {
  return (
    <div ref={incidentRef} className="space-y-5">
      <Formik
        initialValues={{ ...fields }}
        onSubmit={async (values) => {
          handleFilter(values)
        }}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          setFieldValue,
          submitForm
        }) => (
          <Form className="flex flex-col w-full p-6 mx-auto mt-6 bg-white border border-gray-200 rounded-md dark:border-gray-700 dark:bg-gray-800 print:m-0 print:p-0 print:border-0 gap-y-4">
            <div className="hidden w-full print:flex">
              <div className="flex flex-row items-center justify-between w-full overflow-hidden border-white rounded-sm bg-base">
                <img className="-mt-4 -mb-5 size-28" src={logoNormal} alt="" />

                <h2 className="pr-3 text-lg font-medium text-white dark:text-white">
                  Siniestro TUS - Lesionados
                </h2>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4 print:mt-0.5">
              <div className="col-span-12">
                {/* <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3"> */}
                <label
                  className={`${touched.general_search && errors.general_search ? 'text-red-700 dark:text-red-500' : 'text-gray-700 dark:text-gray-200'}`}
                  htmlFor="general_search"
                >
                  Filtro general
                </label>

                <Field
                  id="general_search"
                  name="general_search"
                  placeholder="Nº de Siniestro / Referencia agencia / Referencia TUS / Riesgo siniestro / Estatus"
                  type="text"
                  className={`block w-full p-2 mt-2 border bg-white rounded-sm focus:ring-opacity-40 focus:outline-none focus:ring ${touched.general_search && errors.general_search ? 'border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500' : ' text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-blue-300 dark:focus:border-blue-300'} print:py-1 print:mt-1`}
                  autoComplete="new-password"
                />

                <div
                  className={`flex justify-start items-start w-full ${touched.general_search && errors.general_search ? 'visible' : 'invisible'} print:hidden`}
                >
                  <div className="flex w-full">
                    <p className="mt-1 text-sm leading-none text-red-600 dark:text-red-500">
                      {errors.general_search || '\u00A0'}
                    </p>
                  </div>
                </div>
              </div>

              {type === 'circulation' && (
                <div className="col-span-12">
                  {/* <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3"> */}
                  <label
                    className={`${touched.position && errors.position ? 'text-red-700 dark:text-red-500' : 'text-gray-700 dark:text-gray-200'}`}
                    htmlFor="position"
                  >
                    Posición
                  </label>

                  <Select
                    className="w-full mt-2"
                    onChange={(e) => setFieldValue('position', e.value)}
                    placeholder="Seleccionar..."
                    options={positionOptions}
                    getOptionLabel={(o) => o.label}
                    getOptionValue={(o) => o.value}
                    isSearchable={false}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderRadius: '0.125rem',
                        cursor: 'pointer',
                        boxShadow: state.isFocused
                          ? '0 0 0 calc(3px + 0px) rgba(80, 162, 255, 0.3)'
                          : 'none',
                        minHeight: 'auto',
                        lineHeight: '24px',
                        border: state.isFocused
                          ? '1px solid #50A2FF'
                          : '1px solid rgb(229 231 235 / 1)',
                        '&:hover': {
                          border: '1px solid #50A2FF'
                        },
                        outline: '2px solid transparent',
                        outlineOffset: '2px'
                      }),
                      valueContainer: (baseStyles) => ({
                        ...baseStyles,
                        padding: '0.50rem',
                        position: 'relative',
                        cursor: 'pointer'
                      }),
                      input: (baseStyles) => ({
                        ...baseStyles,
                        display: 'flex',
                        alignItems: 'center',
                        margin: '0',
                        paddingTop: '0',
                        paddingBottom: '0',
                        cursor: 'pointer'
                      }),
                      placeholder: (baseStyles) => ({
                        ...baseStyles,
                        marginLeft: '0',
                        marginRight: '0'
                      }),
                      indicatorsContainer: (baseStyles) => ({
                        ...baseStyles,
                        cursor: 'pointer'
                      }),
                      dropdownIndicator: (baseStyles) => ({
                        ...baseStyles
                      })
                    }}
                    value={positionOptions?.find((option) => {
                      return option.value === values.position
                    })}
                  />

                  <div
                    className={`flex justify-start items-start w-full ${touched.position && errors.position ? 'visible' : 'invisible'} print:hidden`}
                  >
                    <div className="flex w-full">
                      <p className="mt-1 text-sm leading-none text-red-600 dark:text-red-500">
                        {errors.position || '\u00A0'}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3">
                <label
                  className={`${touched.occurrence_date_start && errors.occurrence_date_start ? 'text-red-700 dark:text-red-500' : 'text-gray-700 dark:text-gray-200'}`}
                  htmlFor="occurrence_date_start"
                >
                  F. Ocurrencia (Desde)
                </label>

                <Field
                  id="occurrence_date_start"
                  name="occurrence_date_start"
                  type="date"
                  className={`block w-full leading-none p-2.5 mt-2 border bg-white rounded-sm focus:ring-opacity-40 focus:outline-none focus:ring ${touched.occurrence_date_start && errors.occurrence_date_start ? 'border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500' : ' text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-blue-300 dark:focus:border-blue-300'} print:py-1.5 print:mt-1`}
                />

                <div
                  className={`flex justify-start items-start w-full ${touched.occurrence_date_start && errors.occurrence_date_start ? 'visible' : 'invisible'} print:hidden`}
                >
                  <div className="flex w-full">
                    <p className="mt-1 text-sm leading-none text-red-600 dark:text-red-500">
                      {errors.occurrence_date_start || '\u00A0'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-3">
                <label
                  className={`${touched.occurrence_date_end && errors.occurrence_date_end ? 'text-red-700 dark:text-red-500' : 'text-gray-700 dark:text-gray-200'}`}
                  htmlFor="occurrence_date_end"
                >
                  F. Ocurrencia (Hasta)
                </label>

                <Field
                  id="occurrence_date_end"
                  name="occurrence_date_end"
                  type="date"
                  className={`block w-full leading-none p-2.5 mt-2 border bg-white rounded-sm focus:ring-opacity-40 focus:outline-none focus:ring ${touched.occurrence_date_end && errors.occurrence_date_end ? 'border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500' : ' text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-blue-300 dark:focus:border-blue-300'} print:py-1.5 print:mt-1`}
                />

                <div
                  className={`flex justify-start items-start w-full ${touched.occurrence_date_end && errors.occurrence_date_end ? 'visible' : 'invisible'} print:hidden`}
                >
                  <div className="flex w-full">
                    <p className="mt-1 text-sm leading-none text-red-600 dark:text-red-500">
                      {errors.occurrence_date_end || '\u00A0'}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end mt-6 gap-x-4 print:hidden">
              {/* ── BOTÓN MAPA DE CALOR ── */}
              <button
                type="button"
                title={showHeatmap ? 'Ver marcadores' : 'Ver mapa de calor'}
                className={`flex items-center justify-center w-1/2 px-5 py-2 space-x-2 text-sm transition-colors duration-200 border rounded-sm sm:w-40 focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-accent focus:border-accent dark:focus:border-accent ${
                  showHeatmap
                    ? 'bg-white text-accent border-accent dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600'
                    : 'bg-accent text-white border-accent dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 enabled:hover:bg-white enabled:hover:text-accent dark:enabled:hover:bg-gray-800'
                }`}
                onClick={onToggleHeatmap}
                disabled={!filteredIncidents || filteredIncidents.length === 0}
              >
                {showHeatmap ? (
                  <LuMapPin size={20} />
                ) : (
                  <LuFlame size={20} />
                )}
                <span>{showHeatmap ? 'Marcadores' : 'Mapa de calor'}</span>
              </button>

              <button
                type="submit"
                className="flex items-center justify-center w-1/2 px-5 py-2 space-x-2 text-sm text-white transition-colors duration-200 border rounded-sm bg-accent border-accent sm:w-36 dark:hover:bg-gray-800 enabled:hover:bg-white enabled:hover:text-accent dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:enabled:hover:bg-gray-800 disabled:opacity-30 focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-accent focus:border-accent dark:focus:border-accent"
              >
                <LuFilter size={20} />
                <span>Filtrar</span>
              </button>
            </div>
          </Form>
        )}
      </Formik>

      <div
        className={`flex flex-col w-full bg-white border border-gray-200 rounded-md ${filteredIncidents?.length > 0 ? 'p-1' : 'p-6'} dark:border-gray-700 dark:bg-gray-800 print:border-0 print:p-0`}
      >
        {filteredIncidents?.length > 0 ? (
          <MapContainer
            ref={mapRef}
            center={filteredIncidents[0]?.coordinates?.split(',')}
            zoom={14}
            minZoom={6}
            scrollWheelZoom={true}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />

            {showHeatmap ? (
              /* ── CAPA DE CALOR ── */
              <HeatmapLayer points={filteredIncidents} />
            ) : (
              /* ── MARCADORES NORMALES ── */
              filteredIncidents
                ?.filter((incident) => {
                  if (incident?.coordinates === '') return false
                  if (incident?.coordinates === null) return false
                  if (incident?.coordinates === undefined) return false
                  if (!incident?.coordinates?.includes(',')) return false
                  if (!incident?.coordinates?.split(',')) return false
                  return true
                })
                .map((incident, index) => {
                  return (
                    <CustomMarker
                      key={index}
                      position={incident?.coordinates?.split(',')}
                    >
                      <Popup>
                        <div className="flex flex-col items-start justify-start space-y-1">
                          <span className="font-bold">
                            Nº de Siniestro: {incident?.incident_number}
                          </span>

                          <span>{incident?.occurrence_date}</span>

                          <span>{incident?.coordinates?.split(',')}</span>

                          <Link
                            href={`/${type === 'all' ? 'maps-all' : 'maps'}/${incident?.type}/${incident?.id}`}
                            className="font-medium text-[#FCAE52] dark:text-[#FCAE52]"
                            tabIndex="0"
                            role="link"
                          >
                            Ver
                          </Link>
                        </div>
                      </Popup>
                    </CustomMarker>
                  )
                })
            )}
          </MapContainer>
        ) : (
          <div className="flex justify-start items-start w-full h-[600px]">
            <div className="flex w-full">
              <p className="mt-1 text-sm leading-none text-red-600 dark:text-red-500">
                El mapa no se mostrará si no hay registros para mostrar.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

MapFormDetail.propTypes = {
  type: PropTypes.string,
  fields: PropTypes.object,
  filteredIncidents: PropTypes.array,
  positionOptions: PropTypes.array,
  incidentRef: PropTypes.any,
  mapRef: PropTypes.any,
  handleFilter: PropTypes.func,
  showHeatmap: PropTypes.bool,
  onToggleHeatmap: PropTypes.func
}